import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { CloseOutlined as CloseIcon, ContentCopyOutlined as CopyIcon } from '@mui/icons-material';
import SafeMarkdown from '../../shared/SafeMarkdown';
import { assistantPrimaryButtonSx, assistantTextButtonSx } from '../../freestyle/assistantButtonStyles';
import { assistantDocumentSx } from './assistantDocumentStyles';

export default function GeneratedCapabilityFullscreenDialog({
  open,
  onClose,
  promptText = '',
  onApply,
  title = 'Generated capability',
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(promptText);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper" PaperProps={{ sx: { borderRadius: '8px', m: { xs: 1, sm: 3 }, width: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 48px)' } } }}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, px: { xs: 2, sm: 3 }, py: 1.5 }}>
          <Typography component="span" sx={{ flex: 1, fontSize: '0.9375rem', fontWeight: 600 }}>{title}</Typography>
          <IconButton onClick={handleCopy} title="Copy" aria-label="Copy capability">
            <CopyIcon />
          </IconButton>
          <IconButton onClick={onClose} title="Close" aria-label="Close preview">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 2.5 }}>
          <Box sx={{ '& p': { mb: 1.5 } }}>
            <SafeMarkdown
              sx={{
                ...assistantDocumentSx,
                color: 'text.primary',
                '& p, & li, & h1, & h2, & h3, & h4, & h5, & h6': {
                  color: 'text.primary',
                },
              }}
            >
              {promptText}
            </SafeMarkdown>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} sx={assistantTextButtonSx}>Close</Button>
          {onApply && (
            <Button variant="contained" onClick={() => onApply(promptText)} sx={assistantPrimaryButtonSx}>
              Apply to capability
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ mt: 7, zIndex: (themeValue) => themeValue.zIndex.modal + 3 }}
        message="Copied to clipboard"
      />
    </>
  );
}
